import React from "react";
import { NAV_ADMIN } from "@/lib/nav";
import { KendalaPage } from "@/pages/kepsek/KendalaKepsek";

export default function AdminKendala() {
  return <KendalaPage nav={NAV_ADMIN} dataTestidPrefix="kendala-filter" />;
}
